import type { CommonStore } from './interfaces'

export const actions = {
  setLoading (this: CommonStore, payload: CommonStore['loading']): void {
    this.loading = payload
  },
  setPageType (this: CommonStore, payload: CommonStore['pageType']): void {
    this.pageType = payload
  },
  setModalTutorApplication (this: CommonStore, payload: boolean): void {
    this.modalTutorApplication = payload
  },
  setModalTutorApplicationSuccess (this: CommonStore, payload: boolean): void {
    this.modalTutorApplicationSuccess = payload
  },
}
